import React, { useEffect, useState, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
interface AnimatedCounterProps {
  start: number;
  end: number;
  duration?: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
}
const AnimatedCounter: React.FC<AnimatedCounterProps> = ({
  start = 0,
  end,
  duration = 2500,
  prefix = '',
  suffix = '',
  decimals = 0
}) => {
  const [count, setCount] = useState(start);
  const countRef = useRef(start);
  const {
    ref,
    inView
  } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
  useEffect(() => {
    if (inView) {
      let startTime: number;
      const animateCount = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const currentCount = progress * (end - start) + start;
        countRef.current = currentCount;
        setCount(currentCount);
        if (progress < 1) {
          requestAnimationFrame(animateCount);
        }
      };
      requestAnimationFrame(animateCount);
    }
  }, [inView, start, end, duration]);
  return <div ref={ref} className="inline-block" data-id="element-28">
      <span className="font-bold" data-id="element-29">
        {prefix}
        {count.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        {suffix}
      </span>
    </div>;
};
export default AnimatedCounter;